import ActionPlan from '../components/action_plans/ActionPlan'
import VideoModal from '../components/materials/VideoModal.vue'
import Hover from '../components/Hover.vue';
import { createApp } from 'vue';
import { createPinia } from 'pinia'

const pinia = createPinia();

if (document.getElementById('action-plan-screen')) {
    const app = createApp({
        components: {
            ActionPlan,
            Hover
        }
    });
    
    app.use(pinia);
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#action-plan-screen');
}
